import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Tooltip as TooltipWrapper } from 'dibs-elements/exports/Tooltip';
import { Callout } from './FavoriteCallouts/Callout';
import { TooltipHeader } from 'dibs-elements/exports/TooltipHeader';

class Tooltip extends React.Component {
    constructor(props) {
        super(props);
        this.state = { dismissed: false };
    }

    render() {
        const { type, callout, copy } = this.props;
        const showCallout = callout && callout[type];

        if (this.props.showOnHover && this.props.hovering) {
            return (
                <TooltipWrapper isVisible direction="top">
                    <TooltipHeader title={this.props.copy.header} />
                    <p>{this.props.copy.text}</p>
                </TooltipWrapper>
            );
        } else if (showCallout) {
            return <Callout {...{ copy, type }} />;
        }
        return null;
    }
}

Tooltip.defaultProps = {
    hovering: false,
    showOnHover: false,
};

Tooltip.propTypes = {
    copy: PropTypes.shape({
        header: PropTypes.string,
        text: PropTypes.string,
    }),
    hovering: PropTypes.bool,
    showOnHover: PropTypes.bool,
    type: PropTypes.string,
    callout: PropTypes.object,
};

const mapStateToProps = state => {
    return {
        callout: state.favoritesNotificationsReducer.callout,
    };
};

export default connect(mapStateToProps)(Tooltip);
